import React, { forwardRef } from 'react'
import { LeftSideBarType } from './LeftSideBar'
import { Scroll } from './Scroll'
import './style/layout-container.scss'

/**
 * 
 * description
 * 
 * ###Import to use it
 *
 *```
 *   import { LayoutContainer } from '@eco/react-lib'
 *```
 *
 *### Usage
 *
 *```jsx
 *<LayoutContainer 
 *   label={string} 
 *   description={string}
 />
 *```
 *
 *### Basic Example
 */

export const LayoutContainer = forwardRef(({ children, className, ...props }: LeftSideBarType, ref?: React.Ref<HTMLDivElement>) => {
    return (
        <Scroll {...props} className={`layout-container ${className}`} onScroll={props.onScroll} ref={ref}>
            <div className="layout-wrapper">
                { children }
            </div>
        </Scroll>
    )
})

LayoutContainer.displayName = 'LayoutContainer'
